module.exports = __webpack_public_path__ + "img/ec.7d16932.svg";